import { rankWith, uiTypeIs } from '@jsonforms/core'
import { FILE_FIELD_RENDERER_META } from './FileFieldControl'

export default rankWith(
  5, // increase rank as needed
  uiTypeIs(FILE_FIELD_RENDERER_META.type)
)
